<template lang="pug">
    include SchoolAdminMigration.pug
</template>

<script>
import _ from "underscore";
import Api from "@/components/services/Api"

export default {
    name: 'SchoolAdminMigration',
    data() {
        let currentHost = `${window.location.protocol}//${window.location.host}/`;
        // Data contained on the component
        return {
            action: Api.getApiUrl() + "/esreps/school-pre-migration/",
            redirect: currentHost + "school-admin/migration-escuela-preview",
            error: false,
            updates: [],
            countries: [],
            modes: [],
            courses: [],
            schools: [],
        };
    },
    created() {
        const _this = this;

        this.action += "?token=" + this.$store.state.token;

        // Check if the package has been sent
        if (/\?package=/.test(window.location.href)) {
            let pack = window.location.href.split("?package=")[1];
            Api.migrationPackage(this.$store.state.token, pack).then(resp => {
                let result = resp.data.result;
                let json = JSON.parse(result);

                _this.error = json.error;
                _this.updates = json.updates;
            }).catch();
        }

        Api.migration(this.$store.state.token).then(resp => {
            _this.countries = resp.data.countries;
            _this.courses = resp.data.courses;
            _this.modes = resp.data.modes;
            _this.schools = resp.data.schools;
        }).catch();
    }
}

</script>

<style scoped lang="scss">
@import "./../../variables";
@import "SchoolAdminMigration";
</style>



// WEBPACK FOOTER //
// src/components/school_admin_migration/SchoolAdminMigration.vue